/* eslint-disable no-nested-ternary */
/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable react/prop-types */
/* eslint-disable react/no-unstable-nested-components */
import React, {
  useEffect,
  useMemo,
  useRef,
  useState,
} from 'react';
import { useSelector } from 'react-redux';
import styled from 'styled-components';
import { usePagination, useSortBy, useTable } from 'react-table';
import { useSticky } from 'react-table-sticky';
import IcomoonReact from 'icomoon-react';

import TBTooltip from '../../../../shared/_TBComponents/Tooltip';
import iconSet from '../../../../shared/images/teambuildr-selection.json';

const Styles = styled.div`
  align-items: flex-start;
  background: #FFFFFF;
  display: flex;
  flex-direction: column;
  font-family: nunito sans;
  height: 100%;
  pointer-events: auto;
  width: 100%;

  & .sticky {
    filter: blur(1.2px);
    margin: 25px 10px;
    overflow-x: auto;

    tfoot {
      td:first-child {
        left: 0;
        position: sticky;
      }
    }

    [data-sticky-td] {
      position: sticky;
    }
  }

  .athleteColumnHeaderCell {
    border-bottom: none;
  }

  .athleteNameTitle {
    background-color: #F0F0F0;
    color: #444444;
    font-family: 'Nunito Sans';
    font-size: 16px;
    font-weight: bold;
    max-width: 180px;
    min-width: 180px;
    position: relative;
    text-align: left;
  }

  .footerCells {
    color: #444444;
    font-family: 'Nunito Sans';
    font-size: 16px;
    font-weight: normal;
    text-align: left;
  }

  .noHoverCategoryColumnTitleCell {
    background-color: #F0F0F0;
    border-right: 1px solid #BDBDBD1A;
    border-top-left-radius: 8px;
    color: #444444;
    font-size: 16px;
    font-weight: bold;
    max-width: 270px;
    min-width: 270px;
  }

  .rawValueTitle {
    background-color: #F0F0F0;
    color: #444444;
    font-family: 'Nunito Sans';
    font-size: 16px;
    font-weight: normal;
    max-width: 100px;
    min-width: 100px;
    text-align: left;
  }

  table {
    border-collapse: separate;
    border-spacing: 0;

    tr {
      :last-child {
        td {
          border-bottom: 0;
        }
      }
    }

    th,
    td {
      background: white;
      border-bottom: 1px solid #E0E0E0;
      border-right: 1px solid #BDBDBD1A;
      margin: 0;
      padding: 15px;
      text-align: center;
    }

    tfoot {
      tr:first-child {
        td {
          background: #FCFCFC;
          border-bottom: none;
          border-bottom-left-radius: 8px;
          border-top: 1px solid #E0E0E0;
          height: 61px;
          min-height: 61px;
        }
      }
      td:first-child {
        color: #444444;
        font-family: 'Nunito Sans';
        font-size: 16px;
        font-weight: normal;
        text-align: left;
      }
      tr:last-child {
        display: none;
      }
    }
  }
`;

const Table = ({
  columns,
  data,
  getCellProps,
}) => {
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    footerGroups,
    prepareRow,
    page,
  } = useTable(
    {
      columns,
      data,
      initialState: { pageIndex: 0, pageSize: 5 },
    },
    useSticky,
    useSortBy,
    usePagination,
  );

  return (
    <div id='reportTable' style={{ display: 'flex' }} className='sticky'>
      <table {...getTableProps()}>
        <thead>
          {headerGroups.map((headerGroup) => (
            <tr {...headerGroup.getHeaderGroupProps()} data-a-wrap key={headerGroup.id}>
              {headerGroup.headers.map((column) => (
                <th
                  {...column.getHeaderProps([
                    {
                      className: column.className,
                    },
                  ])}
                  data-a-h='center'
                  data-a-v='center'
                  data-b-a-c='FF000000'
                  data-b-a-s='thin'
                  data-cols-width='30'
                  data-a-wrap
                  data-f-bold
                  data-f-color={column?.style?.fillColor ? 'FF000000;' : 'FFFFFFFF'}
                  data-fill-color={column?.style?.fillColor || 'FF424242'}
                >
                  {column.render('Header')}
                  <span>
                    {column.isSorted
                      ? column.isSortedDesc
                        ? (
                          <IcomoonReact
                            color='black'
                            icon='down-arrow'
                            iconSet={iconSet}
                            size={10}
                            style={{ marginLeft: '5px' }}
                          />
                        )
                        : (
                          <IcomoonReact
                            color='black'
                            icon='up-arrow'
                            iconSet={iconSet}
                            size={10}
                            style={{ marginLeft: '5px' }}
                          />
                        )
                      : ''}
                  </span>
                </th>
              ))}
            </tr>
          ))}
        </thead>
        <tbody {...getTableBodyProps()}>
          {page.map((row) => {
            prepareRow(row);
            return (
              <tr {...row.getRowProps()} key={row.id}>
                {row.cells.map((cell) => (
                  <td
                    {...cell.getCellProps([
                      {
                        style: cell.column.style,
                      },
                      getCellProps(cell),
                    ])}
                    data-a-wrap
                    data-b-a-c='FF000000'
                    data-b-a-s='thin'
                    data-f-color={getCellProps(cell)?.style?.fontColor}
                    data-fill-color={getCellProps(cell)?.style?.fillColor || null}
                  >
                    {cell.render('Cell')}
                  </td>
                ))}
              </tr>
            );
          })}
        </tbody>
        <tfoot>
          {footerGroups.map((group) => (
            <tr {...group.getFooterGroupProps()} key={group.id}>
              {group.headers.map((column) => (
                <td
                  data-a-wrap
                  key={column.id}
                  {...column.getFooterProps([{ className: 'footerCells' }])}
                >
                  {column.render('Footer')}
                </td>
              ))}
            </tr>
          ))}
        </tfoot>
      </table>
      <div
        style={{
          alignItems: 'center',
          background: '#5F8BDC1A',
          border: '1px dashed #5F8BDC',
          borderRadius: '5px',
          color: '#5F8BDC',
          display: 'flex',
          fontFamily: 'NunitoSans',
          fontSize: '16px',
          fontWeight: 'bold',
          justifyContent: 'center',
          textAlign: 'center',
          width: '250px',
        }}
      >
        <span>+ Add Exercise</span>
      </div>
    </div>
  );
};

const SCAnalysisTableNoData = ({
  containerWidth,
  dataRows,
  rowIsScrollable,
  setColumnHeaderHeight,
}) => {
  const { exercises, timingGateExercises } = useSelector((state) => state.sportCoachDashboard.data);

  const [headerAndSubHeaderHeight, setHeaderAndSubHeaderHeight] = useState(0);
  const [isScrollable, setIsScrollable] = useState(false);

  const chartRef = useRef(null);

  const handleScroll = () => {
    // Targeting the sticky container div scroll properties
    if (!chartRef.current) return;
    const scrollWidth = chartRef.current.childNodes[0]?.scrollWidth;
    const offsetWidth = chartRef.current.childNodes[0]?.offsetWidth;
    const scrollLeft = chartRef.current.childNodes[0]?.scrollLeft;
    setIsScrollable(offsetWidth + scrollLeft !== scrollWidth);
  };

  const checkScrollability = () => {
    if (!chartRef.current) return;
    const scrollWidth = chartRef.current.childNodes[0]?.scrollWidth;
    const offsetWidth = chartRef.current.childNodes[0]?.offsetWidth;
    const scrollLeft = chartRef.current.childNodes[0]?.scrollLeft;
    setIsScrollable(offsetWidth + scrollLeft !== scrollWidth);
  };

  const setHeights = () => {
    if (!chartRef.current) return;
    setHeaderAndSubHeaderHeight(
      chartRef.current.childNodes[0].childNodes[0].childNodes[0].clientHeight,
    );
    setColumnHeaderHeight(
      chartRef.current.childNodes[0].childNodes[0].childNodes[0].childNodes[0].clientHeight,
    );
  };

  useEffect(() => {
    checkScrollability();
  }, []);

  useEffect(() => {
    setHeights();
  }, [setColumnHeaderHeight]);

  const athleteNameColumn = [
    {
      Header: '',
      Footer: () => null,
      id: 'name',
      sticky: 'left',
      className: 'athleteColumnHeaderCell',
      columns: [
        {
          Header: 'Athlete',
          accessor: 'name',
          Footer: 'Group Average',
          className: 'athleteNameTitle',
          style: {
            // style for the whole column
            // className is style for just the header
            borderRight: '1px solid #E0E0E0',
            height: '58px',
          },
          Cell: ({ row }) => (
            <TBTooltip
              displayText={row.original.name}
              id={row.original.name}
              hoverText={row.original.name}
              tooltipStyles={{
                backgroundColor: '#FFFFFF',
                color: '#444444',
                fontSize: '12px',
              }}
            />
          ),
        },
      ],
    },
  ];

  const headerText = exercises.length > 0 ? exercises[0].name : timingGateExercises[0].displayName;

  const NoDataColumn = [
    {
      Header: () => headerText || 'Barbell Deadlift',
      Footer: () => null,
      id: 'exerName',
      className: 'noHoverCategoryColumnTitleCell',
      columns: [
        {
          Header: 'Start',
          accessor: 'start',
          Cell: () => (
            <TBTooltip
              textToDisplay=''
              textContainerPadding='0px'
              textContainerMaxWidth='90px'
              fontSize='12px'
              fontColor='black'
            />
          ),
          Footer: '0000.00',
          id: 'startDate',
          className: 'rawValueTitle',
          style: {
            fontWeight: 700,
            minWidth: '90px',
            maxWidth: '90px',
            fillColor: 'FFBDBDBD1A',
          },
        },
        {
          Header: 'End',
          accessor: 'end',
          Cell: () => (
            <TBTooltip
              textToDisplay=''
              textContainerPadding='0px'
              textContainerMaxWidth='90px'
              fontSize='12px'
              fontColor='black'
            />
          ),
          Footer: '0000.00',
          id: 'endDate',
          className: 'rawValueTitle',
          style: {
            fontWeight: 700,
            minWidth: '90px',
            maxWidth: '90px',
            fillColor: 'FFBDBDBD1A',
          },
        },
        {
          Header: 'Change',
          accessor: 'change',
          Cell: () => (
            <TBTooltip
              textToDisplay=''
              textContainerPadding='0px'
              textContainerMaxWidth='90px'
              fontSize='12px'
              fontColor='black'
            />
          ),
          Footer: '0.00',
          id: 'change',
          className: 'rawValueTitle',
          style: {
            fontWeight: 700,
            minWidth: '90px',
            maxWidth: '90px',
            fillColor: 'FFBDBDBD1A',
          },
        },
      ],
    },
  ];

  const columns = [...athleteNameColumn, ...NoDataColumn];
  const memoizedColumns = useMemo(() => columns, [exercises, timingGateExercises]);
  const memoizedDataRows = useMemo(() => dataRows, [dataRows]);

  return (
    <Styles
      containerWidth={containerWidth}
      headerAndSubHeaderHeight={headerAndSubHeaderHeight}
      isScrollable={isScrollable}
      onScroll={handleScroll}
      ref={chartRef}
      rowIsScrollable={rowIsScrollable}
    >
      <Table
        columns={memoizedColumns}
        containerWidth={containerWidth}
        data={memoizedDataRows}
        getCellProps={() => ({
          style: {
            backgroundColor: 'FFFFFFFF',
            color: 'FF444444',
            fillColor: 'FFFFFFFF',
            fontColor: 'FF444444',
          },
        })}
      />
    </Styles>
  );
};

export default SCAnalysisTableNoData;
